import { IssueCategory } from 'src/redux/jira/constants';
import { FilterState, Project, Sort } from 'src/redux/jira/types';

const concatFilterJql = (jql: string, subQuery: string) => {
  if (jql) {
    return `${jql} AND ${subQuery}`;
  }
  return subQuery;
};

const buildJql = (key: string, filterValues: string[]) => {
  return `${key} in ( ${filterValues.toString()} )`;
};

const buildTextSearchJql = (text: string) => {
  // escape double quote from text input as it breaks jql if unhandled
  return `text ~ "${text.replace(/(["])/g, '\\"')}"`;
};

const buildSortJql = (sort: Sort) => {
  return `ORDER BY ${sort.field} ${sort.order}`;
};

export const constructJqlFromFilter = (
  filterState: FilterState,
  relevantProjects: Project[] = []
) => {
  const {
    assignees,
    issueCategories,
    projectIds: projects,
    sort,
    textFilterQuery,
  } = filterState;

  let jql = '';
  if (assignees.length) {
    jql = concatFilterJql(jql, buildJql('assignee', assignees));
  }
  if (issueCategories.length) {
    // replace 'indeterminate' value in JQL's statusCategory to avoid UI error when redirecting to Jira Issue Navigator.
    const issueCategoriesForJql = issueCategories.map(category =>
      category === IssueCategory.InProgress ? '"In Progress"' : category
    );

    jql = concatFilterJql(
      jql,
      buildJql('statusCategory', issueCategoriesForJql)
    );
  }

  if (projects.length) {
    jql = concatFilterJql(jql, buildJql('project', projects));
  } else if (relevantProjects.length) {
    // include relevant projects' id in JQL if no project is selected in filter
    const relevantProjectsIds = relevantProjects.map(project => project.id);
    jql = concatFilterJql(jql, buildJql('project', relevantProjectsIds));
  }

  if (textFilterQuery) {
    jql = concatFilterJql(jql, buildTextSearchJql(textFilterQuery));
  }
  const sortJql = buildSortJql(sort);
  return jql ? `${jql} ${sortJql}` : sortJql;
};
